// @flow
import React, { Component, Fragment } from 'react'; 
import classNames from 'classnames/bind';
import { Desktop, UntilTablet } from '../../../../utils/responsive';
import Slider from 'react-slick/lib'; 

import style from './HappyCustomers.scss'; 

import avatar1 from '../../../../assets/img/home/happy-customers/avatar-1.png';
import avatar2 from '../../../../assets/img/home/happy-customers/avatar-2.png';
import avatar3 from '../../../../assets/img/home/happy-customers/avatar-3.png';
 
type Props = {   
};

type State = {  
};

const messagesList = [
    {
        title: '¡Gracias Qempo!',
        message: 'Qempo hizo un cambio gratis de las zapatillas que pedí de Amazon y no me quedaron. Gracias Qempo!',
        avatar: avatar1,
        customer: 'Sebastián',
        order: 'Compra: Zapatillas Adidas'
    },
    {
        title: 'Confiable al 100%',
        message: 'Hago BJJ y siempre traigo mis G’s de USA con Qempo, Confiable al 100%',
        avatar: avatar2,
        customer: 'Jano',
        order: 'Compra: BJJ Gi'
    },
    {
        title: 'Tomé la mejor decisión',
        message: 'Estuve buscando la mejor opción para comprar mi Macbook de Apple USA y encontré Qempo, tomé la mejor decisión”',
        avatar: avatar3,
        customer: 'Oscar',
        order: 'Compra: Macbook Pro'
    },
];

export default class HappyCustomers extends Component<Props, State> { 

    constructor(props: Props) {
        super(props);
    
    } 
 
    render() { 
        const slidesToShow = 1; 
    
        const settings = {
            infinite: true,
            slidesToScroll: 1,
            dots: true, 
            dotsClass: classNames('slick-dots', style.dots),
            arrows: false, 
            draggable: true, 
            autoplaySpeed: 8000,  
            autoplay: true, 
            speed: 800,
            slidesToShow: slidesToShow,
        };

        return ( 
            <section className={style.happyCustomersWrap}>
                <div className={style.titleWrap}>
                    <h4>Clientes felices</h4>
                </div> 
                <div className={style.happyCustomersContent}> 
                     <Desktop> 
                        {messagesList.map((item, index: number)=> (
                            <div className={style.column} key={`card-message-${index}`}>
                                <div className={style.messageWrap}> 
                                    <h6>{item.title}</h6> 
                                    <span>{item.message}</span> 
                                </div> 
                                <div className={style.avatarWrap}>
                                    <div className={style.imageWrap}>
                                        <img src={item.avatar}/>
                                    </div>
                                    <div className={style.customerWrap}>
                                        <h6>{item.customer}</h6>
                                        <span>{item.order}</span>
                                    </div>
                                </div>
                            </div>
                        ))}  
                    </Desktop>
                    <UntilTablet> 
                        <Slider {...settings}>
                             {messagesList.map((item, index: number)=> (
                                <div className={style.column} key={`card-message-${index}`}>
                                    <div className={style.messageWrap}> 
                                        <h6>{item.title}</h6> 
                                        <span>{item.message}</span> 
                                    </div> 
                                    <div className={style.avatarWrap}>
                                        <div className={style.imageWrap}>
                                            <img src={item.avatar}/>
                                        </div>
                                        <div className={style.customerWrap}>
                                            <h6>{item.customer}</h6>
                                            <span>{item.order}</span>
                                        </div>
                                    </div>   
                                </div>
                            ))}  
                            {/* <div>
                                <h3>1</h3>
                            </div>
                            <div>
                                <h3>2</h3>
                            </div>
                            <div>
                                <h3>3</h3>
                            </div>
                            <div>
                                <h3>4</h3>
                            </div>
                            <div>
                                <h3>5</h3>
                            </div>
                            <div>
                                <h3>6</h3>
                            </div> */}
                        </Slider> 
                    </UntilTablet> 
                </div>
            </section>);
    }
}


HappyCustomers.propTypes = {  
};
 


// WEBPACK FOOTER //
// ./src/modules/home/elements/HappyCustomers/HappyCustomers.jsx